import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const lawnMowerProductQueryOptions = (slug: string) => queryOptions({
  queryKey: ["lawn-mower-product", slug],
  queryFn: async () => {
    const { data, error } = await supabase.from("lawn_mowers").select("*")
      .eq("slug", slug).eq("status", "published").maybeSingle();
    if (error) throw error;
    return data;
  },
});

export const generatorProductQueryOptions = (slug: string) => queryOptions({
  queryKey: ["generator-product", slug],
  queryFn: async () => {
    const { data, error } = await supabase.from("generators").select("*")
      .eq("slug", slug).eq("status", "published").maybeSingle();
    if (error) throw error;
    return data;
  },
});

export const productLandingQueryOptions = (slug: string) => queryOptions({
  queryKey: ["product-landing-public", slug],
  queryFn: async () => {
    const { data, error } = await supabase.from("product_landings").select("*")
      .eq("slug", slug).eq("status", "published").maybeSingle();
    if (error) throw error;
    return data;
  },
});

export const topListQueryOptions = (slug: string) => queryOptions({
  queryKey: ["top-list-public", slug],
  queryFn: async () => {
    const { data, error } = await supabase.from("top_lists").select("*")
      .eq("slug", slug).eq("status", "published").maybeSingle();
    if (error) throw error;
    return data;
  },
});